import React from "react";

import Collapsed from "./Collapsed";

const Simple = ({ ticket, winnerFun }) => {
	return <Collapsed ticket={ticket} winnerFun={winnerFun} />;
};

export default Simple;
